export class ConfigNotLoadedError extends Error {
  constructor() {
    super(`Config hasn't been loaded`);
  }
}

